import { GroupAlertModal } from '@gripp/shared-ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { EditGroupMenu } from './editGroupMenu';
import { GroupAlertButton } from './groupAlertButton';

type Props = {
  groupIds: string[];
};

export const GroupsSelectionPanelMain = ({ groupIds }: Props) => {
  const { t } = useTranslation();
  const [showAlertModal, setShowAlertModal] = useState(false);

  // Both actions target a single group, so only surface them when the
  // selection is exactly one row.
  const groupId = groupIds.length === 1 ? groupIds[0] : undefined;

  return (
    <View style={styles.container}>
      {groupId && (
        <>
          <EditGroupMenu groupId={groupId} label={t('groups.menu.editGroup')} />
          <GroupAlertButton
            groupId={groupId}
            onPress={() => setShowAlertModal(true)}
          />
        </>
      )}
      {showAlertModal && groupId && (
        <GroupAlertModal
          visible={showAlertModal}
          groupId={groupId}
          onClose={() => setShowAlertModal(false)}
        />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: 16,
    gap: 12,
  },
});
